import React, { Dispatch, SetStateAction } from "react";
import {
  CheckMarkIcon,
} from "./micro/icons";

type Props = {
  onClick: () => void;
  isCheckMarked: boolean;
  // setIsCheckMarked: Dispatch<SetStateAction<boolean>>;
};
export const CheckMark = (props: Props) => {
  const { onClick, isCheckMarked } = props;
  return (
    <>
      <div
        onClick={onClick}
        className={(isCheckMarked ? "bg-primary" : "bg-white") + " shrink-0 aspect-square w-8 h-8 mr-3 rounded-sm border-2 border-primary flex justify-center items-center cursor-pointer"}
      >
        <span className={(isCheckMarked ? "" : "hidden ") + "text-white"}>
          <CheckMarkIcon stroke={3.5} />
        </span>
      </div>
    </>
  )
}